<template>
  <div class="goodsTable">
    <!-- 运输载具数据表格 -->
    <vxe-toolbar>
      <template v-slot:buttons>
        <vxe-button
          v-if="$route.query.isEdit == 'Y'"
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          @click="insertEvent()"
          >{{ $t('acceptanceDetail.btnList.add') }}</vxe-button
        >
        <vxe-button
          v-if="$route.query.isEdit == 'Y'"
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          @click="handleDelete('goodsTable')"
          >{{ $t('acceptanceDetail.btnList.remove') }}</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      resizable
      show-overflow
      :data="goodsData"
      :columns="columnList"
      :edit-config="editConfig"
      @edit-actived="editActived"
      highlight-current-row
      @current-change="currentChange"
      ref="goodsTable"
      :edit-rules="goodsTableEditRules"
      show-footer
      :footer-method="footerMethod"
      auto-resize
    >
    </vxe-grid>
    <collectionInfo ref="collectionInfo" :detail="detail"> </collectionInfo>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/capitalCenter/letterOfCredit';
  // import lockExchangeRateTable from './lockExchangeRateTable';
  // import delayPaymentTable from './delayPaymentTable';
  // import delayLockExchangeRateTable from './delayLockExchangeRateTable';
  import collectionInfo from './collectionInfo';
  export default {
    name: 'returnAdd',
    components: {
      // SearchTable,
      // InputNumber,
      // lockExchangeRateTable,
      // delayPaymentTable,
      // delayLockExchangeRateTable,
      collectionInfo,
    },
    props: ['type'],
    data() {
      return {
        activeTabsName: 'lockExchangeRateTable',
        activeAccept: { id: null, tempId: null }, //当前编辑的承兑行
        activeIndex: null,
        showLockExchangeRateTable: false,
        showDelayPaymentTable: false,
        showDelayLockExchangeRateTable: false,
        contractInfo: {
          // contractNos: [],
          orderNos: [],
        },
        detail: [],
        returnStatus: '',
        goodsData: [],
        editConfig: { trigger: 'click', mode: 'cell', activeMethod: this.activeRowMethod },
        ladingNoLoading: false,
        ladingNoOptions: [], //提货仓库下拉数据
        baseData: {
          statusFlag: null,
          isAccpetComplete: false,
          acceptCompleteDate: null,
          isPayComplete: false,
        },
        delayPaymentTypeOptions: [
          {
            label: this.$t('acceptanceDetail.goodsTable.delayPaymentType0'), //不押汇
            value: '0',
          },
          {
            label: this.$t('acceptanceDetail.goodsTable.delayPaymentType1'), //部门不押汇公司押汇
            value: '1',
          },
          {
            label: this.$t('acceptanceDetail.goodsTable.delayPaymentType2'), //部门押汇公司不押汇
            value: '2',
          },
          {
            label: this.$t('acceptanceDetail.goodsTable.delayPaymentType3'), //部门押汇且公司押汇
            value: '3',
          },
        ],
        tableForm: {
          delAccList: [],
          acceptanceList: [],
        },
        delAccList: [],
        contractDetailOptions: [], //合同行对象下拉数据  根据合同变更动态改变
        acceptAmountTotal: 0,
      };
    },
    watch: {},
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        dictList: (state) => state.dict.dictList,
      }),

      columnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            title: this.$t('financeSalesInvoiceDetail.column.sortNo'),
            field: 'sortNo',
            type: 'seq',
            width: 60,
          }, //序号
          // {
          //   title: this.$t('tFundCreditLetterAcceptance.column.contractNo'),
          //   field: 'contractNo',
          //   width: 120,
          //   editRender: { name: 'ElInput', props: { clearable: true } },
          //   slots: {
          //     // 使用 JSX 渲染
          //     default: ({ row }) => {
          //       return [<span>{row.contractNo}</span>];
          //     },
          //     edit: ({ row }) => {
          //       return [
          //         <search-table
          //           searchType="acceptContractDetailRec"
          //           isMultiple={true}
          //           options={this.baseData.contractList}
          //           propName="contractNo"
          //           currentValue={row['contractNo']}
          //           checkRowKeys={[row['contractNo']]}
          //           onInput={(val) => this.updateCol(row, val, 'contractNo')}
          //         ></search-table>,
          //       ];
          //     },
          //   },
          // }, //合同号
          // {
          //   title: this.$t('tFundCreditLetterAcceptance.column.externalContractNo'),
          //   field: 'externalContractNo',
          //   width: 120,
          // }, //外部合同号
          // {
          //   title: this.$t('tFundCreditLetterAcceptance.column.partnerName'),
          //   field: 'partnerName',
          //   width: 120,
          // },
          {
            title: this.$t('tFundCreditLetterAcceptance.column.acceptDate'),
            field: 'acceptDate',
            // width: 180,
            editRender: {
              name: 'ElDatePicker',
              props: {
                clearable: true,
                type: 'date',
                format: 'yyyy/MM/dd',
                valueFormat: 'yyyy-MM-dd',
              },
            },
          }, //承兑日期
          {
            title: this.$t('tFundCreditLetterAcceptance.column.acceptAmount'),
            field: 'acceptAmount',
            // width: 200,
            editRender: { name: 'ElInputNumber', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.acceptAmount}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row['acceptAmount']}
                    placeholder={this.$t('tFundCreditLetterAcceptance.placeholder.acceptAmount')}
                    clearable={true}
                    max={999999999999.99999}
                    onInput={(val) => this.updateCol(row, val, 'acceptAmount')}
                  ></input-number>,
                ];
              },
            },
          }, //承兑金额
          // {
          //   title: this.$t('detailOrAcceptCredit.acceptTable.planPayDate'),
          //   field: 'planPayDate',
          //   width: 180,
          //   editRender: {
          //     name: 'ElDatePicker',
          //     props: {
          //       clearable: true,
          //       type: 'date',
          //       format: 'yyyy/MM/dd',
          //       valueFormat: 'yyyy-MM-dd',
          //     },
          //   },
          // }, //计划收款日期
          // {
          //   title: this.$t('detailOrAcceptCredit.acceptTable.planPayAmount'),
          //   field: 'planPayAmount',
          //   width: 200,
          //   editRender: { name: 'ElInputNumber', props: { clearable: true } },
          //   slots: {
          //     // 使用 JSX 渲染
          //     default: ({ row }) => {
          //       return [<span>{row.planPayAmount}</span>];
          //     },
          //     edit: ({ row }) => {
          //       return [
          //         <input-number
          //           value={row['planPayAmount']}
          //           placeholder={this.$t('tFundCreditLetterAcceptance.placeholder.planPayAmount')}
          //           clearable={true}
          //           max={999999999999.99999}
          //           onInput={(val) => this.updateCol(row, val, 'planPayAmount')}
          //         ></input-number>,
          //       ];
          //     },
          //   },
          // }, //计划收款金额
          // {
          //   title: this.$t('tFundCreditLetterAcceptance.column.remark'),
          //   field: 'remark',
          //   width: 120,
          //   editRender: { name: 'ElInput', props: { clearable: true } },
          // },
          {
            title: this.$t('tFundCreditLetterAcceptance.column.statusFlag'),
            field: 'statusFlag',
            // width: 120,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>
                    {this.getDictValueByType('cl-recieve-acceptStatus', row['statusFlag'])}
                  </span>,
                ];
              },
            },
          }, //承兑状态
          // {
          //   title: this.$t('tFundCreditLetterAcceptance.column.registerNo'),
          //   field: 'registerNo',
          //   width: 180,
          // }, //收款单号
          // {
          //   title: this.$t('tFundCreditLetter.column.voucherCode'),
          //   field: 'voucherCode',
          //   width: 180,
          // }, //凭证编号
          // {
          //   title: this.$t('tFundCreditLetterAcceptance.column.paidDate'),
          //   field: 'paidDate',
          //   width: 120,
          // }, //实际收款日期
          // {
          //   title: this.$t('detailOrAcceptCredit.acceptTable.paidAmount'),
          //   field: 'paidAmount',
          //   width: 120,
          // }, //实际收款金额
          // {
          //   title: this.$t('tFundCreditLetterAcceptance.column.receiveBankName'),
          //   field: 'receiveBankName',
          //   width: 120,
          // }, //收款银行账户名称
          // {
          //   title: this.$t('tFundCreditLetterAcceptance.column.delayPaymentType'),
          //   field: 'delayPaymentType',
          //   width: 120,
          //   editRender: {
          //     name: 'ElSelect',
          //     options: this.delayPaymentTypeOptions,
          //     props: { clearable: true },
          //     events: {
          //       change: (obj) =>
          //         this.updateCol(obj.row, obj.row['delayPaymentType'], 'delayPaymentType'),
          //     },
          //   },
          // }, //0不押汇 1部门不压公司压 2-部门压公司不压 3-部门压公司压
          // {
          //   title: this.$t('tFundCreditLetterAcceptance.column.isLockExchangeRate'),
          //   field: 'isLockExchangeRate',
          //   width: 120,
          //   editRender: { name: 'ElInput', props: { clearable: true } },
          //   slots: {
          //     // 使用 JSX 渲染
          //     default: ({ row }) => {
          //       return [<el-checkbox disabled value={row['isLockExchangeRate']}></el-checkbox>];
          //     },
          //     edit: ({ row }) => {
          //       return [
          //         <el-checkbox
          //           onInput={(val) => this.updateCol(row, val, 'isLockExchangeRate')}
          //           value={row['isLockExchangeRate']}
          //         ></el-checkbox>,
          //       ];
          //     },
          //   },
          // }, //是否锁汇1 是,0 否
        ];
      },
      goodsTableEditRules() {
        return {
          acceptDate: [
            {
              required: true,
              message: this.$t('acceptanceDetail.goodsTable.acceptDate'),
            },
          ],
          acceptAmount: [
            {
              required: true,
              message: this.$t('acceptanceDetail.goodsTable.acceptAmount'),
            },
          ],

          // planPayDate: [
          //   {
          //     required: true,
          //     message: this.$t('acceptanceDetail.goodsTable.planPayDate'),
          //   },
          // ],
          // planPayAmount: [
          //   {
          //     required: true,
          //     message: this.$t('acceptanceDetail.goodsTable.planPayDate'),
          //   },
          // ],
          // contractNo: [
          //   {
          //     required: true,
          //     message: this.$t('acceptanceDetail.goodsTable.contractNo'),
          //   },
          // ],
          // contractDetailNo: [
          //   {
          //     required: true,
          //     message: this.$t('acceptanceDetail.goodsTable.contractDetailNo'),
          //   },
          // ],
        };
      },
    },
    mounted() {
      this.delAccList = [];
    },
    methods: {
      //JSX更新字段
      updateCol(row, val, type) {
        console.log(row, val, type);
        row[type] = val;
        if (type == 'isLockExchangeRate') {
          row.isLockExchangeRate = val;
          // this.$refs.lockExchangeRateTable.acceptanceInfo = row;
          // if (!val) this.$refs.lockExchangeRateTable.goodsData = []; //勾选不锁汇 清空锁汇列表
        } else if (type == 'acceptAmount') {
          row.acceptAmount = val;
          row.planPayAmount = val;
          this.$refs.goodsTable.updateFooter();
        } else if (type == 'delayPaymentType') {
          // this.$refs.delayPaymentTable.acceptanceInfo = row;
          // if (val == '0') this.$refs.delayPaymentTable.goodsData = []; //勾选不押汇 清空押汇列表
        }
      },
      // 表格列的计算
      calRow(row, prop) {
        if (prop == 'unpaidAmount') {
          row[prop] = this.$cal.calCommon(
            row['acceptAmount'] || 0,
            row['paidAmount'] || 0,
            '-',
            'amount'
          );
        }
        return row[prop];
      },
      getDetail(allDetail) {
        this.baseData = allDetail;
        if (allDetail.acceptanceList != null && allDetail.acceptanceList.length > 0) {
          this.goodsData = allDetail.acceptanceList;
          this.$refs.goodsTable.loadData(this.goodsData);
        }

        this.contractInfo.contractNos = allDetail.contractList.map((res) => res.contractNo);
        this.contractInfo.orderNos = allDetail.contractList.map((res) => res.contractDetailNo);
      },
      // 字典格式化
      getDictValueByType(dictType, value) {
        return this.$baseRequest.getDictValueByType(dictType, value);
      },
      // 计算承兑金额不能超过开证金额*（1+溢短装比例）
      calTotalLimit(value) {
        let overShortShippedPercentage = this.$cal.calCommon(
          this.baseData.overShortShippedPercentage,
          100,
          '/'
        );
        let totalLimit = this.$cal.calCommon(
          value,
          this.$cal.calCommon(1, overShortShippedPercentage, '+'),
          '*',
          'amount'
        );
        return totalLimit;
      },
      // 校验金额
      checkTotal() {
        let flag = true;
        let totalLimit = this.calTotalLimit(this.baseData.clAmount);
        if (parseFloat(this.acceptAmountTotal) > parseFloat(totalLimit)) {
          this.$message({
            showClose: true,
            message: '承兑金额不能超过收证金额及溢短装之和（' + totalLimit + '）',
            type: 'error',
            duration: 10000,
          });
          return false;
        }
        return flag;
      },
      // 撤销
      handleWithdraw() {
        const selectedList = this.$refs['goodsTable'].getCheckboxRecords();
        if (selectedList.length != 1) {
          this.$message({
            showClose: true,
            message: this.$t('xTable.onlyOneSelect'),
            type: 'error',
          });
          return;
        }
        if (['002'].indexOf(selectedList[0].statusFlag) == -1) {
          this.$message({
            showClose: true,
            message: '仅有已承兑状态才能撤销',
            type: 'error',
          });
          return;
        }
        const id = selectedList[0].id || selectedList[0].tempId;
        let params = {
          id,
          statusFlag: '001',
        };
        this.$axios.post(API.REVOKELC, params).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              message: '撤销成功',
              type: 'success',
            });
            let index = this.goodsData.findIndex((it) => it.id == selectedList[0].id);
            this.goodsData[index].statusFlag = '001';
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$t('xTable.total');
            }
            if (['acceptAmount'].includes(column.property)) {
              this.acceptAmountTotal = data
                .map((i) => i['acceptAmount'])
                .reduce((acc, cur) => {
                  const num = this.$cal.calCommon(acc, cur, '+', 'amount');
                  return num;
                }, 0);
              return this.acceptAmountTotal;
            }
            return null;
          }),
        ];
      },
      // 载具表格新增一行
      insertEvent() {
        this.$refs.goodsTable.validate().then(() => {
          if (!this.checkTotal()) return;
          let acceptAmount = this.$cal.calCommon(
            this.baseData.clAmount,
            this.acceptAmountTotal,
            '-',
            'amount'
          );
          if (acceptAmount < 0) acceptAmount = 0;
          const record = {
            id: null,
            tempId: new Date().getTime(),
            // contractNo: null,
            // externalContractNo: null,
            acceptDate: null,
            acceptAmount: acceptAmount,
            statusFlag: '',

            // planPayDate: null,
            // planPayAmount: acceptAmount,
            // remark: null,
            // registerNo: null,
            // voucherCode: this.baseData.voucherCode,
            // paidDate: null,
            // paidAmount: 0,
            // receiveBankName: null,
            // delayPaymentType: null,
            // // delayPaymentType: '0',
            // isLockExchangeRate: false,
          };
          this.goodsData.push(record);
          this.$refs.goodsTable
            .insertAt(record, -1)
            .then(({ row }) => this.$refs.goodsTable.setActiveRow(row));
        });
      },
      handleDelete(goodsTable) {
        const selectedList = this.$refs[goodsTable].getCheckboxRecords();
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('acceptanceDetail.msg.removeMsg'),
            type: 'error',
          });
          return;
        }
        let flag = true;
        for (let i = 0; i < selectedList.length; i++) {
          if (['', '001'].indexOf(selectedList[i].statusFlag) == -1) {
            flag = false;
            this.$message({
              showClose: true,
              message: '仅有已保存状态才能删除',
              type: 'error',
            });
            break;
          }
        }
        if (!flag) return;
        this.$confirmAction()
          .then(() => {
            selectedList.map((item) => {
              if (item.id) this.delAccList.push(item.id);
            });
            // 遍历承兑行 更新this.activeIndex
            selectedList.map((it) => {
              let selIndex = this.$refs[goodsTable].getRowIndex(it);
              if (this.activeIndex > selIndex) {
                this.activeIndex--;
              }
            });
            selectedList.map((item) => {
              let index = null;
              if (item.id) {
                index = this.baseData.acceptanceList.findIndex((it) => it.id == item.id);
              } else {
                index = this.baseData.acceptanceList.findIndex((it) => it.tempId == item.tempId);
              }
              this.baseData.acceptanceList.splice(index, 1);
            });
            this.$refs[goodsTable].removeSelecteds();
            this.goodsData = this.$refs[goodsTable].getTableData().fullData;
            this.$refs[goodsTable].updateFooter();
            // 如果删掉所有承兑行，则当前选中行索引设置为-1
            if (this.goodsData.length == 0) this.activeIndex = -1;
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('personnel.table.deletSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('personnel.table.deletFalse'),
            });
          });
        console.log('删除的行', this.baseData.acceptanceList);
      },
      // 返回数据
      exportChildData() {
        return new Promise((resolve, reject) => {
          const tableForm = {};
          //承兑锁汇
          let currentRecord = this.$refs.goodsTable.getCurrentRecord();
          let isLockExchangeRate = currentRecord ? currentRecord.isLockExchangeRate : false;
          // let delayPaymentType = currentRecord ? currentRecord.delayPaymentType : '0';
          typeof isLockExchangeRate != 'boolean'
            ? (isLockExchangeRate = isLockExchangeRate == '1')
            : '';
          let [...acceptanceList] = this.$refs.goodsTable.getTableData().fullData;
          if (acceptanceList.length) {
            acceptanceList.map((item, index) => {
              (item.tenantCode = this.userInfo.tenantCode),
                (item.companyCode = this.userInfo.companyCode),
                (item.companyName = this.userInfo.companyName),
                (item.departmentCode = this.userInfo.departmentCode),
                (item.departmentName = this.userInfo.departmentName),
                (item.sortNo = index + 1);
              item.clCode = this.baseData.clCode;
              item.isArrivalDifference = item.isArrivalDifference ? '1' : '0';
              item.isLockExchangeRate = item.isLockExchangeRate ? '1' : '0';
              item.isPaid = item.isPaid ? '1' : '0';
              item.isRefusePayment = item.isRefusePayment ? '1' : '0';
              return item;
            });
          }

          tableForm.acceptanceList = acceptanceList;
          tableForm.delAccList = this.delAccList;
          console.log(this.baseData.acceptanceList);
          console.log(tableForm);
          // 点击提交，走校验
          this.$refs['goodsTable']
            .validate()
            .then(() => {
              resolve(tableForm);
            })
            .catch(() => {
              reject();
            });
          return;
        });
      },
      // 点击切换承兑行信息
      currentChange(row) {
        //切换时保存当前值
        if (this.activeAccept) {
          // let id = this.activeAccept.id || this.activeAccept.tempId;
          let index = null;
          if (this.activeAccept.id || this.activeAccept.tempId) {
            if (this.activeAccept.id) {
              index = this.baseData.acceptanceList.findIndex((it) => it.id == this.activeAccept.id);
            } else if (this.activeAccept.tempId) {
              index = this.baseData.acceptanceList.findIndex(
                (it) => it.tempId == this.activeAccept.tempId
              );
            }
          }
          console.log(index);
        }
        this.activeAccept = row.row;
        this.activeIndex = row.rowIndex;
      },
      editActived(row) {
        //设置合同的供应商为开证申请受益人
        console.log(row);
      },

      activeRowMethod({ row, columnIndex }) {
        //禁用编辑
        if (this.$route.query.isEdit == 'Y') {
          if (
            [this.columnList.length - 1, this.columnList.length - 2].indexOf(columnIndex) !== -1
          ) {
            return true;
          } else {
            //禁用编辑
            return ['002', '003'].indexOf(row.statusFlag) == -1;
          }
        } else {
          return false;
        }
      },
    },
  };
</script>
<style scoped>
  .acceptBaseInfo {
    float: right;
  }

  .acceptBaseInfoItem {
    margin-right: 20px;
  }
</style>
